import { useAppSelector } from '../../../app/hooks';

export const useFieldTooltip = (fieldName: string): string | undefined => {
    return useAppSelector((state) =>
        Object.keys(state.widget.tooltips).includes(fieldName) ? state.widget.tooltips[fieldName] : undefined,
    );
};
